import { useRole } from "modules/roles/hooks/useRole";

export function useIsContributor() {
  const role = useRole();
  return role?.includes("CONTRIBUTOR");
}
